export const FIND_STATEMENT_TEMPLATE_BY_INDICATOR_ID_SUCCESS = 'FIND_STATEMENT_TEMPLATE_BY_INDICATOR_ID_SUCCESS';

export const findStatementTemplateByIndicatorIdSuccess = statementTemplate => ({
    type: FIND_STATEMENT_TEMPLATE_BY_INDICATOR_ID_SUCCESS,
    payload: { statementTemplate },
});
